import { defineMessages } from 'react-intl';

export default defineMessages({
  finished: 'Finished',
  pending: 'Pending',
  failed: 'Failed',
});
